import "../Css/OwnerProfile.css"
import SoleOwner from '../../img/Owner.svg'
import Partnership from '../../img/partnership.svg'
import Syndicate from '../../img/syndicate.svg'
import HorsePlaceholder from '../../img/ProfileHorsePlaceholder.svg'
import { Avatar } from "@mui/material";
import { useEffect, useState } from "react"
import { setHorseImage } from "../../utils"
function HorseAvatar({item,index,lang,OwnerType}){
    const[isImgLoading,setImgIsLoading] = useState(true);
    const[isImgError,setImgIsError] = useState(false);
    useEffect(()=>{
    
    },[])

    const handleImageLoad = () => {
        setImgIsLoading(false);
    };
    const handleImageError = () => {
        setImgIsError(true);
        setImgIsLoading(false);
    };

    // const setHorseImage=(brandNumber)=>{
    //     console.log(brandNumber,brandNumber[0],'bb')
    //     console.log( window.globalConfig.HorseImage?.replace('{{group}}', brandNumber[0]).replace('{{brandNo}}',brandNumber))
    //     if(window.globalConfig.UseSiteCore==1){
    //         return window.globalConfig.HorseImage?.replace('{{group}}', brandNumber[0]).replace('{{brandNo}}',brandNumber)
    //     }else{
    //         return `${window.globalConfig.SITE_DOMAIN}${window.globalConfig.HORSE_IMAGE_PATH}${brandNumber}_l.jpg`
    //     }

    // }
    return( 
        <div className="my-horse-item">
        <div className="my-horse-avatar">
            <Avatar className="item-avatar"  id = {"HorseAvatar"+item.brandNumber}
                src={isImgLoading?HorsePlaceholder:isImgError?HorsePlaceholder: setHorseImage(item.brandNumber)} 
                onLoad = {handleImageLoad}
                onError={handleImageError}
            />
            <img id = {"HorseAvatar_OwnerType"+item.brandNumber} src = {item.ownerType=='O'?SoleOwner:(item.ownerType=='P'||item.ownerType=='D')?Partnership:Syndicate}/>
        </div>
       
        <div className="item-bottom-content">
            <p  className="fontSize14 lineHeight20" id={"HorseAvatar_Name"+item.brandNumber}>  {lang=='ch'?item.name_ch==""?"未命名":item.name_ch:item.name_en==item.brandNumber?"UNNAMED":item.name_en}
                {/* <img id = {"HorseAvatar_OwnerType"+item.brandNumber} src = {item.ownerType=='O'?SoleOwner:(item.ownerType=='P'||item.ownerType=='D')?Partnership:Syndicate} style={{top:'0.125rem',marginLeft:'4px',position:'relative'}}/> */}
            </p>
           
        </div>
    </div>
)

}
export default HorseAvatar